import { Grid } from "@material-ui/core";
import { Add, MeetingRoom } from "@material-ui/icons";
import { orderBy } from "lodash";
import React, { FC } from "react";
import { ExamSessionViewModel } from "../../model/ExamSessionViewModel";
import { RoomAssignmentViewModel } from "../../model/RoomAssignmentViewModel";
import TitleWithIcon from "../common/TitleWithIcon";
import CustomButton from "../common/buttons/CustomButton";
import RightButtonArea from "../common/buttons/RightButtonArea";
import TranslatedMessage from "../translations/TranslatedMessage";
import RoomAssignmentCard from "./RoomAssignmentCard";

interface IRoomAssignmentListProps {
  examSession: ExamSessionViewModel;
  roomAssignments: RoomAssignmentViewModel[];
  locationId: string;
  isReadOnly: boolean;
  onStartAddingRoomAssignment?: () => void;
  onDeleteRoomAssignment?: (roomAssignmentId: string) => void;
}

const RoomAssignmentList: FC<IRoomAssignmentListProps> = ({
  roomAssignments,
  onStartAddingRoomAssignment,
  ...cardProps
}) => {
  const sortedRoomAssignments = orderBy(roomAssignments, (room) => room.roomId.toLowerCase());
  const roomCards = sortedRoomAssignments.map((roomAssignment) => (
    <Grid item={true} xs={12} sm={6} md={4} lg={3} xl={2} key={roomAssignment.roomId}>
      <RoomAssignmentCard {...cardProps} roomAssignment={roomAssignment} />
    </Grid>
  ));

  return (
    <>
      <Grid container={true} spacing={0} alignItems="baseline">
        <Grid item={true} xs={12} sm={6}>
          <TitleWithIcon title={<TranslatedMessage id="roomAssignment.header" />} variant="h4">
            <MeetingRoom />
          </TitleWithIcon>
        </Grid>
        {!cardProps.isReadOnly && (
          <Grid item={true} xs={12} sm={6}>
            <RightButtonArea>
              <CustomButton
                tooltip={<TranslatedMessage id="roomAssignment.button.new" />}
                onClick={onStartAddingRoomAssignment!}
              >
                <Add />
              </CustomButton>
            </RightButtonArea>
          </Grid>
        )}
      </Grid>
      <Grid container={true} spacing={2}>
        {roomCards}
      </Grid>
    </>
  );
};

RoomAssignmentList.defaultProps = {
  onStartAddingRoomAssignment: () => {},
  onDeleteRoomAssignment: () => {},
} as Partial<IRoomAssignmentListProps>;

export default RoomAssignmentList;
